export default "__VITE_ASSET__16f7c4e2__"